import { render, staticRenderFns } from "./PageAds.vue?vue&type=template&id=15f32cc6&scoped=true&"
import script from "./PageAds.vue?vue&type=script&lang=js&"
export * from "./PageAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f32cc6",
  null
  
)

export default component.exports